// extracted by mini-css-extract-plugin
export default {"title":"PaymentToWholesalerDetails_title__sEeT2","total":"PaymentToWholesalerDetails_total__p2r0j","pay":"PaymentToWholesalerDetails_pay__9RVEc"};